module.exports = __webpack_public_path__ + "img/bt5.21724650.png";